export default __webpack_public_path__ + "static/media/background-landing-1.2662cbc8.png";